import React, { FC } from 'react';
import { CardImage, Link } from '@blueprint/ui';
import {
    StyledCard,
    PropertyDetails,
    StyledPropertyTitle,
    StyledPropertyAddress,
    AgentImage,
    AgentImageWrapper,
    PropertyDetailsContainer,
    PropertyImage,
    StyledPropertyPrice
} from './FeaturedProperties.styles';
import { FeaturedPropertyData } from './FeaturedProperties.types';

export type Props = {
    property: FeaturedPropertyData;
    currentSection: 'for-sale' | 'to-rent';
    onClick?: () => void;
};

const FeaturedPropertyCard: FC<Props> = (props) => {
    const { property, currentSection, onClick } = props;
    const { tags, featuredType } = property;

    const hasTag = tags.some((tag) => tag.content === 'New home');
    const isWeeklyFeatured = featuredType === 'weekly_featured';
    return (
        <Link
            plain
            href={`/${hasTag ? 'new-homes' : currentSection}/details/${
                property.listingId
            }?${
                isWeeklyFeatured ? 'weekly_featured' : 'featured'
            }=1&utm_content=featured_listing`}
            key={property.listingId}
            onClick={onClick}
            data-testid="featured-property-card"
        >
            <StyledCard
                hasShadow={false}
                hasBorder={false}
                hasBackground
                contentAlignment="center"
            >
                <PropertyImage>
                    <CardImage
                        src={property.image.src}
                        responsiveImgList={property.image.responsiveImgList}
                    />
                </PropertyImage>
                <PropertyDetailsContainer>
                    <PropertyDetails>
                        <StyledPropertyPrice color="text-title" size="6" isBold>
                            {property.price}
                        </StyledPropertyPrice>
                        <StyledPropertyTitle color="text-title" size="8" isBold>
                            {property.title}
                        </StyledPropertyTitle>
                        <StyledPropertyAddress
                            color="text-body"
                            size="secondary"
                        >
                            {property.address}
                        </StyledPropertyAddress>
                    </PropertyDetails>
                    <AgentImageWrapper>
                        <AgentImage
                            src={property.branch.logoUrl}
                            alt={property.branch.name}
                        />
                    </AgentImageWrapper>
                </PropertyDetailsContainer>
            </StyledCard>
        </Link>
    );
};

export default FeaturedPropertyCard;
